function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "reaction");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("polygon", {
  points: "4.09 12.84 4.09 35.62 24.19 47.38 44.19 35.83 44.19 12.84 24.14 1.08 4.09 12.84"
}), React.createElement("polyline", {
  points: "4.09 12.84 24.14 24.23 44.19 12.84"
}), React.createElement("line", {
  x1: 24.14,
  y1: 24.23,
  x2: 24.19,
  y2: 47.38
}));

var SvgFigure4 = function SvgFigure4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    width: 48.38,
    height: 48.38,
    viewBox: "0 0 48.38 48.38",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFigure4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/figure-4.b28e0a96.svg";
export { ForwardRef as ReactComponent };